import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router/routes';
import { registerUnauthenticatedHandler } from '@/services/api-client/apiClient';

function AppInner() {
  useEffect(() => {
    registerUnauthenticatedHandler(() => {
      router.navigate('/login', { replace: true });
    });
  }, []);

  return <RouterProvider router={router} />;
}

export default function App() {
  return (
    <AppProviders>
      <AppInner />
    </AppProviders>
  );
}
